import React from 'react';
import { observer } from 'mobx-react';
import { mdiCloudUploadOutline } from '@mdi/js';
import Icon from '@mdi/react';

interface IUploadFile {
  disabled: boolean;
  id: string;
  fileType: string;
  name: string;
  className?: string; // add as additional property
  iconColor: string;
  onChange: (event: {}) => void;
  onClick: (event: { target: any }) => void;
}

const UploadFileComponent = (props: IUploadFile) => {
  return (
    <div>
      <div className={`usa-form-group ` + props.className}>
        <div className="usa-file-input__target p-4">
          <div className="usa-file-input">
            <Icon path={mdiCloudUploadOutline} title="upload" size={2} color={props.iconColor} />
            <div className="usa-file-input_instructions" aria-hidden="false">
              <label className="usa-file-input__drag-text" htmlFor={props.id}>
                Drop your <strong>{props.fileType} file </strong> here or click to select a file.
              </label>
            </div>
            <div className="usa-file-input__box"></div>
            <input
              id={props.id}
              className="usa-file-input__input" // links to css
              type="file"
              name={props.name}
              accept={props.fileType}
              onChange={props.onChange}
              onClick={props.onClick}
              disabled={props.disabled}
              data-testid="the-UploadFile"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const UploadFile = observer(UploadFileComponent);
